import { connect } from 'react-redux'
import PublicRoute from './PublicRoute'

const mapStateToProps = state => ({
  auth: state.auth
})

export default connect(
  mapStateToProps
)(PublicRoute)



// WEBPACK FOOTER //
// ./src/components/Layout/PublicRoute/index.js